import qs from "qs";
import authBaseAxios from "../utils/api";
import {
  IApWorkflowBscResponse,
  IApWorkflowCommentHistoryResponse,
  IEspWorkflowDetailResponse,
  IMatchingDetailResponse,
} from "../interfaces/workflow";
import { ITourEventOrOtherWorkflowResponse } from "../interfaces/ap-workflow";

export const WorkflowServices = {
  getAllApWorkflow: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`ap-workflow?${queryString}`);
  },

  getApWorkflowDetail: (id: string): Promise<IMatchingDetailResponse> => {
    return authBaseAxios.get(`ap-workflow/${id}`);
  },

  updateApWorkflowDetail: (id: string, body: any): Promise<any> => {
    return authBaseAxios.put(`ap-workflow/${id}`, body);
  },

  postApWorkflowDetailConfirmMatch: (id: string, body: any): Promise<any> => {
    return authBaseAxios.post(`ap-workflow/${id}/confirm-match`, body);
  },

  getSearchEsp: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`ap-workflow/search-esp?${queryString}`);
  },

  getApWorkflowBsc: (params: any): Promise<IApWorkflowBscResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`ap-workflow/get-bsc?${queryString}`);
  },

  getApWorkflowComments: (id: string): Promise<IApWorkflowCommentHistoryResponse> => {
    return authBaseAxios.get(`ap-workflow/${id}/comments`);
  },

  getSearchSir: (params: any): Promise<any> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`ap-workflow/search-sir?${queryString}`);
  },

  getMatchingDetail: (id: string): Promise<IMatchingDetailResponse> => {
    return authBaseAxios.get(`ap-workflow/matching-detail/${id}`);
  },

  updateMatchingDetail: (id: string, body: any): Promise<any> => {
    return authBaseAxios.put(`ap-workflow/matching-detail/${id}`, body);
  },

  validateConfirmMatch: (id: string, body: any): Promise<any> => {
    return authBaseAxios.put(`ap-workflow/matching-detail/${id}/validate-confirm-match`, body);
  },

  postMatchingDetailConfirmMatch: (id: string, body: any): Promise<any> => {
    return authBaseAxios.post(`ap-workflow/matching-detail/${id}/confirm-match`, body);
  },

  generatePdf: (id: string, sirId: string): Promise<Blob> => {
    return authBaseAxios.get(`ap-workflow/matching-detail/${id}/generate-pdf/${sirId}`, {
      responseType: "blob",
    });
  },

  getAllEspWorkflow: (params: any): Promise<ITourEventOrOtherWorkflowResponse> => {
    const queryString = qs.stringify(params, { arrayFormat: "repeat" });
    return authBaseAxios.get(`esp-workflow?${queryString}`);
  },

  getEspWorkflowDetail: (id: string): Promise<IEspWorkflowDetailResponse> => {
    return authBaseAxios.get(`esp-workflow/${id}`);
  },

  getEspWorkflowComments: (id: string): Promise<IApWorkflowCommentHistoryResponse> => {
    return authBaseAxios.get(`esp-workflow/${id}/comments`);
  },

  updateEspWorkflowDetail: (id: string, body: any): Promise<any> => {
    return authBaseAxios.put(`esp-workflow/${id}`, body);
  },
};
